import { ReactNode } from 'react';
import { AlertModalTypeEnum, useAlertModal } from '.';

export function useWarningAlert() {
  const { setAlertModalProps, showAlertModal, closeAlertModal } = useAlertModal();

  return ({
    onConfirm,
    title = '',
    text = '',
    content = '',
    confirmLabel = 'Confirm',
    type = AlertModalTypeEnum.WARNING_REVERSIBLE,
    titleIconOverride,
  }: {
    onConfirm: () => void | Promise<void>,
    title?: string
    text?: string,
    content?: string,
    confirmLabel?: string,
    type?: AlertModalTypeEnum
    titleIconOverride?: ReactNode,
  }) => {
    setAlertModalProps({
      isOpen: true,
      title,
      titleIconOverride,
      contentHighlight: text,
      content,
      confirmLabel,
      type,
      onClose: () => { closeAlertModal(); },
      onConfirm: () => {
        onConfirm();
        closeAlertModal();
      },
    });
    showAlertModal();
  };
}
